import { OmakasePlayerClientConfig } from '@/__configs/config_types';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { useConfigValue } from '@/components/_hooks/useConfigValue';
import styled from '@emotion/styled';
import { Fade, IconButton, useTheme } from '@mui/material';
import React, { Suspense } from 'react';
import VideoWithDeliverables from './VideoWithDeliverables';

const VideoPlayer = React.lazy(() => import('../../../_common/VideoPlayer/VideoPlayer'));

interface ProxyVideoProps {
  toggleVideo: () => void;
  id?: string;
  url: string;
  poster: string;
}

const ProxyVideo = ({ id, toggleVideo, url, poster }: ProxyVideoProps) => {
  const features = useConfigValue<OmakasePlayerClientConfig['features']>(['omakasePlayerConfig', 'features']);
  const hasAdvancedVideoFeaturesEnabled = !!features?.length;
  const theme = useTheme();

  return (
    <Fade in timeout={600}>
      <Wrapper hideBefore={hasAdvancedVideoFeaturesEnabled}>
        <IconButton onClick={toggleVideo} size="large" style={{ position: 'absolute', top: theme.spacing(1), left: theme.spacing(1), zIndex: 99 }}>
          <PolarisIcon icon="left_arrow" style={{ fontSize: '2rem', color: '#fff' }} />
        </IconButton>
        <Suspense fallback={<div>Loading...</div>}>
          {hasAdvancedVideoFeaturesEnabled ? (
            <VideoWithDeliverables id={id} url={url} poster={poster} />
          ) : (
            <VideoPlayer id={id} url={url} poster={poster} />
          )}
        </Suspense>
      </Wrapper>
    </Fade>
  );
};

export default ProxyVideo;

const Wrapper = styled.div<{ hideBefore?: boolean }>`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: white;

  ${({ hideBefore }) =>
    !hideBefore
      ? `
      &:before {
        content: '';
        background: #000;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
      }
    ` : null}
`;
